"use client";

import React from "react";
import { Target } from "lucide-react";
import { GuideElement, type GuideElementProps } from "../BaseDemoElement";
import { useResponsiveCardStyle } from "@/hooks/use-responsive-card-style";

type WelcomeComponentProps = Omit<GuideElementProps, "title" | "description" | "icon"> & {
  title?: string;
  description?: string;
};

export function WelcomeComponent({
  title = "Welcome to Creators Search",
  description = "You're on the Creators Search page. Here you fill out your profile, showcase your portfolio, get invitations from brands, and manage collaborations — all in one place.",
  ...rest
}: WelcomeComponentProps) {
  // Get responsive styles using centralized hook
  const cardStyle = useResponsiveCardStyle("lg", "wide");
  
  const mergedStyle = {
    ...cardStyle,
    ...(rest.style || {}),
  } as GuideElementProps["style"];
  
  return (
    <GuideElement
      title={title}
      description={description}
      icon={Target}
      position={rest.position ?? "center"}
      spotlight={rest.spotlight ?? false}
      showArrow={false}
      style={mergedStyle}
      {...rest}
    >
    </GuideElement>
  );
}

